import { styled } from "@linaria/react"

import { Horizontal, Vertical } from "@/components/Flex.ts"
import { ScrollableContainer } from "@/components/Scrollable/Scrollable.tsx"

import type { Property } from "csstype"

export const TaskViewSceneStyles = {
  Container: styled(Horizontal)<{ chatOnly: boolean }>`
    justify-content: ${props => props.chatOnly ? "center" : "normal"};
    flex-grow: 1;
    height: 0;

    view-transition-name: task-view;
  `,

  ChatContainer: styled(Vertical)<{ chatOnly: boolean; width?: string }>`
    flex: 1 1 auto;
    width: ${props => props.chatOnly ? "auto" : props.width || "40%"};
    max-width: ${props => props.chatOnly ? "var(--chat-width)" : "none"};
    padding: ${props => props.chatOnly ? "0" : "16px 0 0 0"};
  `,

  ChatContainerInner: styled(Vertical)<{ chatOnly: boolean }>`
    flex: 1;
    width: 100%;
    overflow: hidden;
  `,

  TabsContainer: styled(Horizontal)<{ width?: string }>`
    flex: 1 1 auto;
    width: ${props => props.width || "60%"};

    padding: 16px 24px;

    box-shadow: -8px 0 20px oklch(0% 0 0deg / 3%);
    border-radius: var(--border-radius-24) 0 0 var(--border-radius-24);
    z-index: 2;
  `,

  Title: styled(Horizontal)<{ chatOnly: boolean }>`
    align-items: center;
    gap: 8px;

    margin: ${props => props.chatOnly ? "0" : "6px"} 32px 16px 0;
    z-index: 1;

    &:empty {
      display: none;
    }
  `,

  NewProjectHeader: styled.div`
    margin-bottom: 16px;

    font-size: 25px;
    font-weight: 500;
    line-height: 60px;
    text-align: center;
  `,

  ScrollableWithInput: styled(Vertical)<{ resizable: boolean }>`
    flex: 1;

    position: relative;
    min-height: 0;
    width: ${props => props.resizable ? "calc(100% - 8px)" : "100%"};

    ${ScrollableContainer} {
      z-index: 0;
    }
  `,

  InviteDeveloper: styled(Horizontal)`
    justify-content: center;
    gap: 16px;

    margin: 0 16px;
    padding: 16px 0;
    background: var(--background-color);
  `,

  InputContainer: styled.div<{ scrollbarWidth: number }>`
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;

    padding-right: ${props => props.scrollbarWidth}px;
  `,

  TypingIndicatorContainer: styled.div<{ scrollbarWidth: number }>`
    position: absolute;
    right: 0;
    bottom: 100%;
    left: 0;

    padding: 0 32px 8px 0;
    padding-right: ${props => 32 + props.scrollbarWidth}px;

    display: flex;
    justify-content: center;
    pointer-events: none;
  `,

  InputWrapper: styled.div<{ resizable: boolean, transparent?: boolean, marginTop?: Property.MarginTop }>`
    position: relative;
    max-width: calc(var(--chat-width) + 64px);
    margin: ${props => props.marginTop != undefined ? `${props.marginTop} auto 0` : "0 auto"};
    padding: 0 32px 26px ${props => props.resizable ? "0" : "32px"};

    &::before {
      content: '';

      position: absolute;
      top: 0;
      right: 32px;
      bottom: 0;
      left: ${props => props.resizable ? "0" : "32px"};

      background: ${props => props.transparent ? "transparent" : "linear-gradient(to bottom, transparent 0%, var(--background-color) 50%, var(--background-color) 100%)"};
      pointer-events: none;
      z-index: 0;
    }
  `,

  Footer: styled.div`
    position: relative;
  `,
}